import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/route.config';
import store from '@/store';
import utils from '@/utils/utils';

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: process.env.BUILD_CI ? 'hash' : 'history',
  linkActiveClass: 'active',
  routes: [],
});

router.beforeEach((to, from, next) => {
  const authenticated = store.getters['user/authenticated'];
  if (to.matched.some(match => match.meta.auth === true) && !authenticated) {
    router.push({ name: Vue.$app.route.LOGIN });
    return;
  }
  if (to.matched.some(match => match.meta.auth === false) && authenticated) {
    router.push({ name: Vue.$app.route.PROJECTS });
    return;
  }
  next();
});

router.afterEach((to) => {
  const routeWithTitle = to.matched.slice().reverse().find(route => route.meta && route.meta.title);
  if (routeWithTitle) {
    document.title = router.app.$t(routeWithTitle.meta.title);
  }

});

const unwatch = store.watch(() => store.getters.baseUrlPath, (value) => {
  if (!utils.isUndefined(value)) {
    // Include prefix redirection
    const actualRoutes = [{
      path: value,
      redirect: { name: Vue.$app.route.ROOT },
    }, ...routes.map((route) => {
      const temp = route;
      // base and wildcard
      if (route.path !== '/' && route.path !== '/*') {
        temp.path = `${value}${route.path}`;
      }
      return temp;
    })];
    router.addRoutes(actualRoutes);
    store.dispatch('initRouter');
    unwatch();
  }
});

Vue.router = router;

export default {
  router,
};
